import QueryKeys from '@/utils/QueryKeys';
import { plato_api_program_lessons_path } from '@/modules/routes';
import { UseQueryOptions } from '@tanstack/react-query';
import { BaseLesson, ExtraAttributes, LessonSchema } from '@/types/api/v2/LessonSchema';
import useApi from './useApi';

interface UseLessonsParams<K extends (keyof BaseLesson)[], E extends (keyof ExtraAttributes)[]> {
  extra_attributes?: E;
  only?: K;
  params?: object;
}

type UseLessonsOptions<K extends (keyof BaseLesson)[], E extends (keyof ExtraAttributes)[]> =
  UseLessonsParams<K, E> & Omit<UseQueryOptions<LessonSchema<K[number], E[number]>[]>, 'queryFn' | 'queryKey'>;

export default function useLessons<
  K extends(keyof BaseLesson)[],
  E extends (keyof ExtraAttributes)[],
>(
  programId: number,
  {
    extra_attributes = ([] as any as E),
    only,
    params = {},
    ...queryOptions
  }: UseLessonsOptions<K, E> = {} as UseLessonsOptions<K, E>) {
  return useApi<LessonSchema<K[number], E[number]>[], BaseLesson, K, ExtraAttributes, E>({
    endpoint: programId ? plato_api_program_lessons_path(programId, { extra_attributes, only }) : '',
    extra_attributes,
    only,
    params,
    placeholderData: [],
    queryKey: [QueryKeys.Lessons, programId, extra_attributes, only],
    ...queryOptions,
  });
}
